import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

const { colors, spacing, common, typography } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		overflow: 'hidden',
		padding: spacing.lg,
	},
	layout: {
		display: 'flex',
		flex: 1,
		gap: spacing.lg,
		minHeight: 0,
		overflow: 'hidden',
	},
	formSection: {
		background: colors.background.light,
		border: common.border,
		borderRadius: common.borderRadius,
		boxShadow: '0 0 6px 0 rgba(139,139,139,0.30)',
		flex: '0 0 400px',
		maxHeight: '100%',
		overflowY: 'auto',
		padding: spacing.lg,
	},
	resultsSection: {
		background: colors.background.light,
		border: common.border,
		borderRadius: common.borderRadius,
		boxShadow: '0 0 6px 0 rgba(139,139,139,0.30)',
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		maxHeight: '100%',
		overflow: 'hidden',
	},
	resultsContent: {
		flex: 1,
		overflowY: 'auto',
		padding: spacing.lg,
	},
	loadingContainer: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
		justifyContent: 'center',
		padding: spacing.xxxl,
	},
	formGroup: {
		display: 'flex',
		flexDirection: 'column',
		marginBottom: spacing.md,
	},
	label: {
		color: colors.text.main,
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.bold,
		marginBottom: spacing.sm,
	},
	sectionTitle: {
		borderBottom: `1px solid ${colors.border.light}`,
		color: colors.text.main,
		fontSize: typography.fontSizes.md,
		fontWeight: typography.fontWeights.bold,
		marginBottom: spacing.md,
		paddingBottom: spacing.sm,
	},
	currentSubscriptionCard: {
		background: colors.background.main,
		border: common.border,
		borderRadius: common.borderRadius,
		marginBottom: spacing.lg,
		padding: spacing.md,
	},
	subscriptionRow: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		marginBottom: spacing.sm,
	},
	subscriptionLabel: {
		color: colors.text.light,
		fontSize: 13,
	},
	subscriptionValue: {
		color: colors.text.main,
		fontSize: typography.fontSizes.sm,
		fontWeight: 600,
	},
	componentsSection: {
		borderTop: `1px solid ${colors.border.light}`,
		marginTop: 12,
		paddingTop: 12,
	},
	componentsList: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
		marginTop: spacing.xs,
	},
	componentItem: {
		color: colors.text.main,
		fontSize: 13,
		paddingLeft: spacing.sm,
	},
	checkboxGrid: {
		columnGap: `${spacing.md}px`,
		display: 'grid',
		gridTemplateColumns: 'repeat(1, 1fr)',
		marginTop: spacing.xs,
		rowGap: 12,
	},
	checkboxLabel: {
		alignItems: 'center',
		color: colors.text.main,
		cursor: 'pointer',
		display: 'flex',
		fontSize: typography.fontSizes.sm,
		gap: spacing.sm,
	},
	checkboxDisabled: {
		color: colors.text.light,
		cursor: 'not-allowed',
	},
	quantityContainer: {
		alignItems: 'center',
		background: colors.background.main,
		border: common.border,
		borderRadius: 4,
		display: 'flex',
		gap: 12,
		marginLeft: spacing.lg,
		marginTop: spacing.sm,
		padding: '8px 12px',
	},
	quantityInput: {
		border: common.border,
		borderRadius: 4,
		fontSize: typography.fontSizes.sm,
		padding: '4px 8px',
		textAlign: 'center',
		width: 60,
	},
	buttonRow: {
		display: 'flex',
		gap: 12,
		justifyContent: 'center',
		marginTop: spacing.lg,
	},
	placeholder: {
		color: colors.text.light,
		fontSize: typography.fontSizes.md,
		textAlign: 'center',
	},
	spinnerContainer: {
		alignItems: 'center',
		display: 'flex',
		height: '100%',
		justifyContent: 'center',
	},
	previewTitle: {
		borderBottom: `2px solid ${colors.border.main}`,
		color: colors.text.main,
		fontSize: typography.fontSizes.lg,
		fontWeight: typography.fontWeights.bold,
		marginBottom: 20,
		paddingBottom: 12,
	},
	resultRow: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		padding: '8px 0',
	},
	resultLabel: {
		color: colors.text.main,
		fontSize: typography.fontSizes.sm,
	},
	resultValue: {
		color: colors.text.main,
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.bold,
	},
	highlightedRow: {
		background: colors.success.light,
		borderRadius: 4,
		margin: '8px 0',
		padding: '12px 16px',
	},
	highlightedLabel: {
		color: colors.success.main,
		fontSize: 15,
		fontWeight: 600,
	},
	highlightedValue: {
		color: colors.success.main,
		fontSize: typography.fontSizes.lg,
		fontWeight: typography.fontWeights.bold,
	},
	breakdown: {
		borderBottom: `2px solid ${colors.border.main}`,
		marginBottom: spacing.md,
		paddingBottom: spacing.md,
	},
	summaryRow: {
		display: 'flex',
		gap: spacing.md,
		marginBottom: spacing.md,
	},
	summaryCard: {
		background: colors.background.main,
		border: common.border,
		borderRadius: common.borderRadius,
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		fontSize: typography.fontSizes.sm,
		gap: spacing.sm,
		padding: spacing.md,
	},
	actionButtons: {
		display: 'flex',
		gap: 12,
		justifyContent: 'center',
		marginTop: spacing.lg,
	},
	errorMessage: {
		background: colors.danger.light,
		border: `1px solid ${colors.danger.main}`,
		borderRadius: common.borderRadius,
		color: colors.danger.main,
		padding: spacing.md,
		textAlign: 'center',
	},
	successModal: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.lg,
		padding: spacing.xxl,
		textAlign: 'center',
	},
	successTitle: {
		color: colors.success.main,
		fontWeight: typography.fontWeights.bold,
		margin: 0,
	},
	successMessage: {
		color: colors.text.main,
		fontSize: typography.fontSizes.md,
		lineHeight: 1.5,
		margin: 0,
	},
	invoiceLink: {
		color: colors.primary.main,
		fontWeight: 600,
		textDecoration: 'none',
		':hover': {
			textDecoration: 'underline',
		},
	},
	confirmModal: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.lg,
		padding: spacing.xxl,
		textAlign: 'center',
	},
	confirmTitle: {
		color: colors.text.main,
		fontWeight: typography.fontWeights.bold,
		margin: 0,
	},
	confirmMessage: {
		color: colors.text.main,
		fontSize: typography.fontSizes.md,
		lineHeight: 1.5,
		margin: 0,
	},
	confirmAmount: {
		color: colors.success.main,
		fontSize: typography.fontSizes.xl,
		fontWeight: typography.fontWeights.bold,
	},
	confirmButtons: {
		display: 'flex',
		gap: 12,
		justifyContent: 'center',
	},
	componentAlreadyOwned: {
		color: colors.text.light,
		fontSize: typography.fontSizes.xs,
		marginLeft: 28,
	},
	// Billing cycle change modal
	billingCycleModal: {
		maxWidth: 500,
		padding: spacing.lg,
	},
	billingCycleModalTitle: {
		color: colors.text.main,
		fontSize: typography.fontSizes.lg,
		fontWeight: typography.fontWeights.bold,
		marginBottom: spacing.md,
		textAlign: 'center',
	},
	billingCycleOption: {
		border: `1px solid ${colors.border.light}`,
		borderRadius: common.borderRadius,
		cursor: 'pointer',
		marginBottom: 12,
		padding: spacing.md,
		transition: 'border-color 0.2s, background-color 0.2s',
		':hover': {
			borderColor: colors.border.main,
		},
	},
	billingCycleOptionSelected: {
		backgroundColor: colors.primary.light,
		borderColor: colors.primary.main,
	},
	billingCycleOptionTitle: {
		alignItems: 'center',
		display: 'flex',
		fontWeight: 600,
		gap: spacing.sm,
		marginBottom: spacing.xs,
	},
	billingCycleOptionDescription: {
		color: colors.text.light,
		fontSize: 13,
		lineHeight: 1.4,
	},
	billingCycleModalButtons: {
		display: 'flex',
		gap: 12,
		justifyContent: 'flex-end',
		marginTop: spacing.md,
	},
	// Immediate change preview styles
	serviceCreditRow: {
		color: colors.success.main,
		fontWeight: 500,
	},
	immediateChangeSection: {
		backgroundColor: colors.warning.light,
		border: `1px solid ${colors.warning.main}`,
		borderRadius: common.borderRadius,
		marginBottom: spacing.md,
		padding: spacing.md,
	},
	immediateChangeSectionTitle: {
		color: colors.warning.contrastText,
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.bold,
		marginBottom: 12,
	},
	remainingCreditNote: {
		color: colors.text.light,
		fontSize: typography.fontSizes.xs,
		fontStyle: 'italic',
		marginTop: spacing.xs,
	},
	// Info box for ineligibility
	infoBox: {
		backgroundColor: colors.background.main,
		border: `1px solid ${colors.border.light}`,
		borderRadius: common.borderRadius,
		color: colors.text.main,
		fontSize: 13,
		padding: spacing.md,
	},
	infoBoxTitle: {
		fontWeight: 600,
		marginBottom: spacing.sm,
	},
	infoBoxList: {
		listStyle: 'disc',
		margin: '8px 0',
		paddingLeft: 20,
	},
	// Scheduled product change message
	scheduledChangeMessage: {
		backgroundColor: colors.success.light,
		border: `1px solid ${colors.success.main}`,
		borderRadius: common.borderRadius,
		color: colors.success.main,
		fontSize: typography.fontSizes.sm,
		marginBottom: spacing.md,
		padding: 12,
	},
	// Radio indicator
	radioIndicator: {
		alignItems: 'center',
		border: `2px solid ${colors.border.light}`,
		borderRadius: '50%',
		display: 'flex',
		height: 18,
		justifyContent: 'center',
		width: 18,
	},
	radioIndicatorSelected: {
		borderColor: colors.primary.main,
	},
	radioIndicatorDot: {
		backgroundColor: colors.primary.main,
		borderRadius: '50%',
		height: 10,
		width: 10,
	},
});
